import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useScreen } from "@/hooks";
import { FlexBox, FlexItem } from "@/components/common/display";


/**
 * Represents a grid with a sidebar that changes
 * to a stacked representation at smaller screen sizes.
 */
const __default__ = {
  name: "SidebarGrid",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "header"),
    _createVNode(_unref(FlexBox), { column: _unref(smallWindow) }, {
      default: _withCtx(() => [
        _createVNode(_unref(FlexItem), {
          parts: _unref(smallWindow) ? '12' : '4',
          "full-width": _unref(smallWindow),
          class: _normalizeClass(_unref(smallWindow) ? '' : 'q-pr-md')
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "sidebar")
          ]),
          _: 3
        }, 8, ["parts", "full-width", "class"]),
        _createVNode(_unref(FlexItem), {
          parts: _unref(smallWindow) ? '12' : '8',
          "full-width": _unref(smallWindow)
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["parts", "full-width"])
      ]),
      _: 3
    }, 8, ["column"])
  ]))
}
}

})